import {ChangeEventHandler } from 'react';
import { useI18n } from 'src/utils/lni18n';

import classes from "./partlist.module.scss";
import { PartWithThumbnail } from '../domain/CourseEditModel';
import { PartSmallDragging } from './PartSmallDragging';


export interface ListProps {
    searchText: string,
    textChange: ChangeEventHandler,
    items: PartWithThumbnail[],
    themeParts:  Record <string, boolean>,
    onContextMenu: (e: React.MouseEvent, part: PartWithThumbnail)=>void,
    partUrl: (partId: string) => string
}


const CoursePartListAndSelect = (props: ListProps) => {

    const { searchText, items, textChange, themeParts, onContextMenu, partUrl } = props;
    const { languageService: t } = useI18n();

    if (!items) return null;

    return <>
        <div className='d-flex align-items-center'>
            <input value={searchText} type="text" onChange={textChange} placeholder={t.getText("search.min.x.chars", "3")} className="max-col-width input form-control" />
        </div>
        <div className={`mt-3 d-flex flex-wrap ${classes.coursePartList}`} aria-live="polite">
            {items.map((p) => (
                <PartSmallDragging onContextMenu={(e)=>onContextMenu(e, p)} notDraggable={ themeParts[p.Id] !== undefined } key={p.Id} part={p} to={partUrl(p.Id)} />
            ))}

        </div>

    </>
}


export default CoursePartListAndSelect;